<template>
  <div>
    <main-scn
      :title="$t('antiCorruption.mainTitle')"
      :highlighted-word-index="1"
      image-url-path="footer-links/fundo-anticorrupcao.jpg"
    />
    <scn>
      <section-header
        :title="$t('antiCorruption.introduction.title')"
        :subtitle="$t('antiCorruption.introduction.subtitle')"
      />
      <div class="scn__content container">
        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center">
          <div class="two-col-content__col mr-2 md:mr-0 md:px-5">
            <p v-for="paragraph in $t('antiCorruption.introduction.paragraphs')" class="mb-3">
              {{ paragraph }}
            </p>
          </div>
          <div class="two-col-content__col mt-4 sm-l:mt-0 md:mt-0 md:pr-5">
            <img :src="$getImage('footer-links/juntos-somos-mais-fortes.svg')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
        </div>
      </div>
    </scn>
    <scn color="grey">
      <section-header
        :title="$t('antiCorruption.ourBusiness.title')"
        :subtitle="$t('antiCorruption.ourBusiness.subtitle')"
      />
      <div class="scn__content container">
        <p v-for="paragraph in $t('antiCorruption.ourBusiness.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>
      </div>
    </scn>
    <scn>
      <section-header
        :title="$t('antiCorruption.ourPolitic.title')"
        :subtitle="$t('antiCorruption.ourPolitic.subtitle')"
      />
      <div class="scn__content container">
        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center">
          <div class="two-col-content__col">
            <img :src="$getImage('onesti-logo/a-symbol-gray.svg')" :alt="`${$t('alt.logo')} Onesti`" class="onesti-logo-image">
          </div>
          <div class="two-col-content__col mt-4 sm-l:mt-0 md:mt-0 md:pr-5">
            <p v-for="paragraph in $t('antiCorruption.ourPolitic.paragraphs')" class="mb-3">
              {{ paragraph }}
            </p>
          </div>
        </div>
      </div>
    </scn>
    <scn color="grey">
      <section-header
        :title="$t('antiCorruption.ourRelationships.title')"
        :subtitle="$t('antiCorruption.ourRelationships.subtitle')"
      />
      <div class="scn__content container">
        <p v-for="paragraph in $t('antiCorruption.ourRelationships.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>
      </div>
    </scn>
    <scn>
      <section-header
        :title="$t('antiCorruption.ourCommitment.title')"
        :subtitle="$t('antiCorruption.ourCommitment.subtitle')"
      />
      <div class="scn__content container">
        <p v-for="paragraph in $t('antiCorruption.ourCommitment.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>
        <download-button pdf-file-name="anticorrupcao.pdf" />
      </div>
    </scn>
  </div>
</template>

<script>
import MainScn from '@/components/main-scn'
import DownloadButton from '@/components/download-button'
export default {
  name: 'AntiCorruption',
  components: { DownloadButton, MainScn }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.onesti-logo-image
  @apply block w-32 mx-auto
  @screen md
    @apply w-1/3
</style>
